import React from 'react'
import ContentLoader from 'react-content-loader' 

const CommentsLoading = () => {
    return (
        <div className="">
        <ContentLoader
            viewBox="0 0 500 500"
            height={500}
            width={500}
            speed={2}
        >
            <circle cx="70.2" cy="73.2" r="41.3" />
            <rect x="129.9" y="30" width="140" height="17" />
            <rect x="129.9" y="60" width="220" height="17" />
            <rect x="129.9" y="90" width="300" height="17" />
            
            <circle cx="70.2" cy="200" r="41.3" />
            <rect x="129.9" y="165" width="140" height="17" />
            <rect x="129.9" y="195" width="220" height="17" />
            <rect x="129.9" y="225" width="300" height="17" />

            <circle cx="70.2" cy="330" r="41.3" />
            <rect x="129.9" y="290" width="140" height="17" />
            <rect x="129.9" y="320" width="220" height="17" />
            <rect x="129.9" y="350" width="300" height="17" />

            <circle cx="70.2" cy="460" r="41.3" />
            <rect x="129.9" y="420" width="140" height="17" />
            <rect x="129.9" y="450" width="220" height="17" />
            <rect x="129.9" y="480" width="300" height="17" />
        </ContentLoader>
        </div>
    )
}

export default CommentsLoading
